import Divider from '@mui/material/Divider';
import DefaultLogo from '@shared/assets/air/iconBlack.png';
import { Grid, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';

const CardAir = ({
  i,
  element,
  handleScroll,
  selectedId,
  currency,
  bestPrice,
  isCustomSearch,
}) => {
  const theme = useTheme();

  const elem = useMemo(() => {
    if (!isCustomSearch) return element;

    const selectedCombination = element?.combinations?.find(
      c => c.cluster?.cluster_id === selectedId
    );

    return selectedCombination || element?.combinations?.[0];
  }, [element, selectedId, isCustomSearch]);

  const isActive = selectedId === elem.cluster?.cluster_id;

  return (
    <>
      <Grid
        item
        xs={12}
        sm={2}
        key={`${elem.cluster_id}-${i}-${elem.cluster.carrier.description}`}
        id={`card-air-${i}`}
        onClick={() => handleScroll(elem)}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          alignSelf: 'stretch',
          justifyContent: 'space-between',
          height: '100%',
          cursor: 'pointer',

          borderBottom: '6px solid transparent',
          transition: 'border-color 0.2s ease',

          '&:hover': {
            borderBottomColor: theme.primary,
            '.bestPriceAirCardName': { fontWeight: 700 },
            '.bestPriceAirCardPrice': { fontWeight: 400 },
          },

          ...(isActive && {
            '.bestPriceAirCardPrice': { fontWeight: 600, color: '#000' },
            '.bestPriceAirCardName': { fontWeight: 600, color: '#000' },
          }),

          mb: { xs: '1rem', sm: 0 },
          maxWidth: { xs: '100%', sm: '230px' },
          minWidth: { xs: '100%', sm: '220px' },
        }}
      >
        <img
          style={{ width: 35, height: 35 }}
          src={elem.cluster.carrier.logo || DefaultLogo}
          alt={elem.cluster.carrier.description}
        />

        <Typography
          className="bestPriceAirCardName"
          sx={{
            fontSize: '18px',
            textAlign: 'center',
            fontWeight: 300,
            color: '#211915',
            width: '100%',
            lineHeight: 1.2,

            minHeight: '2.4em',
          }}
        >
          {elem.cluster.carrier.description || elem.cluster.carrier.code}
        </Typography>

        <Typography
          className="bestPriceAirCardPrice"
          sx={{
            fontSize: '18px',
            color: 'black',
            fontWeight: 300,
            lineHeight: 1.2,
            pb: '2px',
          }}
        >
          {currency(elem.cluster.composition_price.total)}
        </Typography>
      </Grid>

      {i < bestPrice.length - 1 && (
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            height: '72px !important',
            alignSelf: 'center !important',
            display: { xs: 'none', sm: 'block' },
          }}
        />
      )}
    </>
  );
};

export default CardAir;
